/**
 * 排出事業者
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";
import * as types from "../../../mutation-types/driver-types";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/emissions`;

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0,
    },
    condition: {
      limit: 50,
      free_word: null,
      code: null,
      name: null,
      number: null,
      manifest_type: null,
      billing_address_code: null,
      billing_address_name: null,
      location_code: null,
      location_name: null,
      unregister_location: false,
      unregister_billing_address: false,
      sort_type: "sort_priority_asc",
      mail_address_setting: null,
      edi_request_status: null,
      dxe_emission_mode: null,
      emitter_mail_approval: null,
    },
  };
};
const emission = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: (state) => {
      return state.pagination.total_count > 0;
    },
  },
  actions: {
    /**
     *
     * @param dispatch
     * @param commit
     * @param state
     * @param free_word
     * @param code
     * @param name
     * @param number
     * @param manifest_type
     * @param billing_address_code
     * @param billing_address_name
     * @param location_code
     * @param location_name
     * @param unregister_location
     * @param unregister_billing_address
     * @param sort_type
     * @param mail_address_setting
     * @param edi_request_status
     * @param dxe_emission_mode
     * @param emitter_mail_approval
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index(
      { dispatch, commit, state },
      {
        free_word,
        code,
        name,
        number,
        manifest_type,
        billing_address_code,
        billing_address_name,
        location_code,
        location_name,
        unregister_location,
        unregister_billing_address,
        sort_type,
        mail_address_setting,
        edi_request_status,
        dxe_emission_mode,
        emitter_mail_approval,
        page,
        limit,
        format,
      }
    ) {
      let api_path;
      if (format === "csv") {
        api_path = `${API_PATH}.csv`;
      } else {
        api_path = `${API_PATH}`;
      }
      dispatch("saveCondition", {
        free_word: free_word,
        code: code,
        name: name,
        number: number,
        manifest_type: manifest_type,
        billing_address_code: billing_address_code,
        billing_address_name: billing_address_name,
        location_code: location_code,
        location_name: location_name,
        unregister_location: unregister_location,
        unregister_billing_address: unregister_billing_address,
        sort_type: sort_type,
        mail_address_setting: mail_address_setting,
        edi_request_status: edi_request_status,
        dxe_emission_mode: dxe_emission_mode,
        emitter_mail_approval: emitter_mail_approval,
        limit: limit,
      });
      const params = {
        free_word: state.condition.free_word,
        code: state.condition.code,
        name: state.condition.name,
        number: state.condition.number,
        manifest_type: state.condition.manifest_type,
        billing_address_code: state.condition.billing_address_code,
        billing_address_name: state.condition.billing_address_name,
        location_code: state.condition.location_code,
        location_name: state.condition.location_name,
        unregister_location: state.condition.unregister_location,
        unregister_billing_address: state.condition.unregister_billing_address,
        sort_type: state.condition.sort_type,
        mail_address_setting: state.condition.mail_address_setting,
        edi_request_status: state.condition.edi_request_status,
        dxe_emission_mode: state.condition.dxe_emission_mode,
        emitter_mail_approval: state.condition.emitter_mail_approval,
        limit: limit,
        page: page,
      };
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then((data) => {
          if (format != "csv") {
            let content = data.content;
            commit(types.DRIVER_EMISSION, { content });
            resolve(content);
          } else {
            resolve(data);
          }
        });
      });
    },
    show({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`;
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then((data) => {
          resolve(data.content);
        });
      });
    },
    new() {
      const api_path = `${API_PATH}/new`;
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then((data) => {
          resolve(data.content);
        });
      });
    },
    create({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.post(API_PATH, params).then((data) => {
          let content = data.content;
          commit(
            "snackbar/showInfo",
            { message: "登録しました" },
            { root: true }
          );
          resolve(content);
        });
      });
    },
    edit({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`;
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then((data) => {
          resolve(data.content);
        });
      });
    },
    update({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}`;
      return new Promise((resolve) => {
        Vue.$http.patch(api_path, params).then((data) => {
          let content = data.content;
          commit(
            "snackbar/showInfo",
            { message: "更新しました" },
            { root: true }
          );
          resolve(content);
        });
      });
    },
    destroy({ commit }, { id, params }) {
      console.log(params);
      const api_path = `${API_PATH}/${id}`;
      return new Promise((resolve) => {
        Vue.$http.delete(api_path, { params: params }).then((data) => {
          commit(
            "snackbar/showInfo",
            { message: "削除しました" },
            { root: true }
          );
          resolve(data.content);
        });
      });
    },
    /**
     * 登録排出事業者のテナント内の件数取得
     * お試しプランの件数チェック用に検索条件を無視して件数を取得する
     * @param commit
     * @return {Promise<unknown>}
     */
    check({ commit }) {
      const params = {};
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then((data) => {
          let content = data.content;
          resolve(content);
        });
      });
    },
    /**
     * EDI申込メール一括送信
     * @param commit
     * @param emission_ids
     * @return {Promise<unknown>}
     */
    sendEdiApplicationMail({ commit }, { emission_ids }) {
      const api_path = `${API_PATH}/edi_requests`;
      const params = { emission_ids: emission_ids };
      return new Promise((resolve) => {
        Vue.$http.post(api_path, params).then((data) => {
          resolve(data.content);
        });
      });
    },
    saveCondition(
      { commit, state },
      {
        free_word,
        code,
        name,
        number,
        manifest_type,
        billing_address_code,
        billing_address_name,
        location_code,
        location_name,
        unregister_location,
        unregister_billing_address,
        sort_type,
        mail_address_setting,
        edi_request_status,
        dxe_emission_mode,
        emitter_mail_approval,
        limit,
      }
    ) {
      const _free_word =
        free_word !== undefined ? free_word : state.condition.free_word;
      const _code = code !== undefined ? code : state.condition.code;
      const _name = name !== undefined ? name : state.condition.name;
      const _number = number !== undefined ? number : state.condition.number;
      const _manifest_type =
        manifest_type !== undefined
          ? manifest_type
          : state.condition.manifest_type;
      const _billing_address_code =
        billing_address_code !== undefined
          ? billing_address_code
          : state.condition.billing_address_code;
      const _billing_address_name =
        billing_address_name !== undefined
          ? billing_address_name
          : state.condition.billing_address_name;
      const _location_code =
        location_code !== undefined
          ? location_code
          : state.condition.location_code;
      const _location_name =
        location_name !== undefined
          ? location_name
          : state.condition.location_name;
      const _unregister_location =
        unregister_location !== undefined
          ? unregister_location
          : state.condition.unregister_location;
      const _unregister_billing_address =
        unregister_billing_address !== undefined
          ? unregister_billing_address
          : state.condition.unregister_billing_address;
      const _sort_type =
        sort_type !== undefined ? sort_type : state.condition.sort_type;
      const _mail_address_setting =
        mail_address_setting !== undefined
          ? mail_address_setting
          : state.condition.mail_address_setting;
      const _edi_request_status =
        edi_request_status !== undefined
          ? edi_request_status
          : state.condition.edi_request_status;
      const _dxe_emission_mode =
        dxe_emission_mode !== undefined
          ? dxe_emission_mode
          : state.condition.dxe_emission_mode;
      const _emitter_mail_approval =
        emitter_mail_approval !== undefined
          ? emitter_mail_approval
          : state.condition.emitter_mail_approval;
      const _limit = limit !== undefined ? limit : state.condition.limit;
      const params = {
        free_word: _free_word,
        code: _code,
        name: _name,
        number: _number,
        manifest_type: _manifest_type,
        billing_address_code: _billing_address_code,
        billing_address_name: _billing_address_name,
        location_code: _location_code,
        location_name: _location_name,
        unregister_location: _unregister_location,
        unregister_billing_address: _unregister_billing_address,
        mail_address_setting: _mail_address_setting,
        edi_request_status: _edi_request_status,
        dxe_emission_mode: _dxe_emission_mode,
        emitter_mail_approval: _emitter_mail_approval,
        sort_type: _sort_type,
        limit: _limit,
      };
      commit(types.DRIVER_EMISSION_CONDITION, { params });
    },
    resetState({ commit }) {
      commit(types.DRIVER_EMISSION_RESET_CONDITION);
    },
    resetPagination({ commit }) {
      commit(types.DRIVER_EMISSION_RESET_PAGINATION);
    },
  },
  mutations: {
    [types.DRIVER_EMISSION_RESET_CONDITION](state) {
      Object.assign(state, getDefaultState());
    },
    [types.DRIVER_EMISSION_RESET_PAGINATION](state) {
      Object.assign(state.pagination, getDefaultState().pagination);
    },
    [types.DRIVER_EMISSION](state, { content }) {
      state.pagination = content.pagination;
    },
    [types.DRIVER_EMISSION_CONDITION](state, { params }) {
      state.condition.free_word = params.free_word;
      state.condition.code = params.code;
      state.condition.name = params.name;
      state.condition.number = params.number;
      state.condition.manifest_type = params.manifest_type;
      state.condition.billing_address_code = params.billing_address_code;
      state.condition.billing_address_name = params.billing_address_name;
      state.condition.location_code = params.location_code;
      state.condition.location_name = params.location_name;
      state.condition.unregister_location = params.unregister_location;
      state.condition.unregister_billing_address =
        params.unregister_billing_address;
      state.condition.mail_address_setting = params.mail_address_setting;
      state.condition.edi_request_status = params.edi_request_status;
      state.condition.dxe_emission_mode = params.dxe_emission_mode;
      state.condition.emitter_mail_approval = params.emitter_mail_approval;
      state.condition.sort_type = params.sort_type;
      state.condition.limit = params.limit;
    },
  },
};

export default emission;
